<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t("requisition") }}</h4>
        </div>
      </div>
      <div v-if="can('purchase.purchase_entry', 'W')" class="page-btn">
        <!-- Trigger Button for Modal -->
        <router-link :to="{name : 'RequisitionCreate'}" class="btn btn-added">
          <i class="ti ti-circle-plus me-2 text-white"></i>{{ $t("add_requisition") }}
        </router-link>
      </div>
    </div>

    <!-- /product list -->
    <div class="card table-list-card">
      <div class="card-body">
        <div class="table-responsive">
          <DataTable v-if="batches.length" :tableId="'batchesTable'">
            <thead>
              <tr>
                <th class="text-center">{{ $t("requisition_no") }}</th>
                <th class="text-center">{{ $t("requisition_date") }}</th>
                <th class="text-center">{{ $t("requisition_by") }}</th>
                <th class="text-center">{{ $t("number_of_items") }}</th>
                <th class="text-center">{{ $t("status") }}</th>
                <th class="text-end">{{ $t("action") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="batch in batches" :key="batch.id">
                <td class="text-center">{{ batch.requisition_no }}</td>
                <td class="text-center">{{ batch.requisition_date }}</td>
                <td class="text-center">{{ batch.requisition_by?.username }}</td>
                <td class="text-center">{{ batch.number_of_items }}</td>
                <td class="text-center">{{ batch.status }}</td>
                <td class="text-end">
                	 <button class="btn btn-sm btn-info" @click="itemDetailsModal(batch.id)">view</button>
                </td>
              </tr>
            </tbody>
          </DataTable>
          <!-- If No Data -->
          <div v-else class="d-flex flex-column align-items-center justify-content-center p-5 bg-light rounded shadow-sm">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#6c757d" class="mb-3" viewBox="0 0 16 16">
              <path d="M8 0a8 8 0 1 0 8 8A8.009 8.009 0 0 0 8 0zm0 15A7 7 0 1 1 15 8a7.008 7.008 0 0 1-7 7z"/>
              <path d="M5.354 4.646a.5.5 0 0 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
            </svg>
            <h5 class="text-muted">No Data Found</h5>
            <p class="text-secondary small">Try adjusting filters or add new data.</p>
          </div>
        </div>
      </div>
    </div>
    <ItemModal :items="items"/>
  </div>
</template>

<script>
import { can as canAccess } from "@/helpers/permission";
import apiUrls from '@/urls';
import DataTable from '@/components/common/DataTable.vue';
import ItemModal from '@/views/admin_dashboard/requisitions/ItemModal.vue';

export default {
  inject: ['globalLoading'],
  components: {
    DataTable,
    ItemModal,
  },
  data() {
    return {
      batches: [],
      items:[],
    };
  },
  methods: {
    async itemDetailsModal(id){
      this.requisition_id = id
      const response = await this.$axios.get(apiUrls.purchase_requisition_items.get, {
            params: { requisition_id: id }
          });
      this.items = response.data;

      this.$nextTick(() => {
        const modal = new bootstrap.Modal(document.getElementById('list-modal'));
        modal.show();
      });
    },
    async fetchBatches() {
      this.globalLoading(true)
      try {
        const response = await this.$axios.get(apiUrls.purchase_requisition.get);
        this.batches = response.data;

      } catch (error) {
        console.error("Error fetching batches:", error);
      } finally {
        this.globalLoading(false)
      }
    },

    can(code, requiredLevel) {
      return canAccess(code, requiredLevel);
    },
  },

  created() {
    this.fetchBatches();
  }
};
</script>
